(() => {
  const $ = (selector, root = document) => root?.querySelector?.(selector) || null;
  const $$ = (selector, root = document) => root?.querySelectorAll ? [...root.querySelectorAll(selector)] : [];
  const currency = window.Shopify?.currency?.active || 'EUR';
  const money = cents => {
    const amount = (Number(cents) || 0) / 100;
    return currency === 'EUR' ? `€${amount.toFixed(2).replace('.', ',')}` : new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency }).format(amount);
  };
  const checkoutCatalog = (() => {
    try { return JSON.parse(document.getElementById('CheckoutFlowCatalog')?.textContent || '{}'); }
    catch (error) { return {}; }
  })();
  const checkoutProducts = checkoutCatalog.products || {};
  const checkoutVariant = variantId => {
    for (const product of Object.values(checkoutProducts)) {
      const variant = product?.variants?.find(candidate => String(candidate.id) === String(variantId));
      if (variant) return { product, variant };
    }
    return null;
  };
  const checkoutVariantForRow = row => {
    const giftSelect = $('[data-bundle-choice]', row);
    if (giftSelect) return Number(giftSelect.options[giftSelect.selectedIndex]?.dataset.variantId || 0);
    const product = checkoutProducts[row.dataset.componentHandle];
    if (!product?.variants?.length) return 0;
    const propertyFields = $$('[data-property-name]', row);
    const size = propertyFields.find(field => /Taille$/i.test(field.dataset.propertyName || ''))?.value;
    const color = propertyFields.find(field => /Couleur$/i.test(field.dataset.propertyName || ''))?.value;
    const variant = product.variants.find(candidate => (
      (!size || String(candidate.option1).toLocaleLowerCase('fr') === String(size).toLocaleLowerCase('fr')) &&
      (!color || String(candidate.option2).toLocaleLowerCase('fr') === String(color).toLocaleLowerCase('fr'))
    ));
    return Number(variant?.id || product.variants[0].id || 0);
  };
  const checkoutItemsForTier = (active, tier, root) => {
    const paidRows = $$('[data-component-handle], .bundle-product-row--picker', tier);
    let paidVariantIds = paidRows.map(checkoutVariantForRow).filter(Boolean);
    if (!paidVariantIds.length) {
      const currentVariantId = Number($('[data-current-variant]', tier)?.value || 0);
      if (currentVariantId) paidVariantIds = [currentVariantId];
    }
    const total = Math.max(0, Number(active.dataset.price) || 0);
    let paidPrices = [];
    if (active.value === 'ensemble' && paidVariantIds.length === 2) {
      paidPrices = [7968, 7032];
    } else if (active.value === 'short-3' && paidVariantIds.length === 3) {
      paidPrices = [4667, 4667, 4666];
    } else if (paidVariantIds.length) {
      const part = Math.floor(total / paidVariantIds.length);
      paidPrices = paidVariantIds.map((variantId, index) => index === paidVariantIds.length - 1 ? total - (part * index) : part);
    }
    const items = paidVariantIds.map((variantId, index) => `${variantId}:${paidPrices[index] || 0}`);
    $$('.bundle-gifts [data-bundle-choice]', tier).forEach(select => {
      const variantId = Number(select.options[select.selectedIndex]?.dataset.variantId || 0);
      if (variantId) items.push(`${variantId}:0`);
    });
    if ($('[data-property-name="Cadeau 1"]', tier)) {
      const chainVariantId = Number(checkoutProducts['logo-chain']?.variants?.[0]?.id || 0);
      if (chainVariantId) items.push(`${chainVariantId}:0`);
    }
    return items.join('|');
  };
  const escapeHtml = value => String(value ?? '').replace(/[&<>'"]/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  $$('[data-product-recommendations]').forEach(recommendation => {
    const cards = $$('[data-recommendation-card]', recommendation);
    const limit = Math.max(1, Number(recommendation.dataset.limit) || 4);
    for (let index = cards.length - 1; index > 0; index -= 1) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      [cards[index], cards[randomIndex]] = [cards[randomIndex], cards[index]];
    }
    cards.forEach(card => { card.hidden = true; });
    cards.slice(0, limit).forEach(card => { card.hidden = false; });
    recommendation.classList.add('is-ready');
  });
  const toast = (message = 'Ajouté au panier', error = false) => {
    const element = $('[data-toast]');
    if (!element) return;
    element.textContent = message;
    element.classList.toggle('is-error', error);
    element.classList.add('is-visible');
    clearTimeout(element._timer);
    element._timer = setTimeout(() => element.classList.remove('is-visible'), 2500);
  };

  const menuToggle = $('[data-menu-toggle]');
  const sideMenu = $('[data-side-menu]');
  const menuScrim = $('[data-menu-scrim]');
  const closeMenu = () => {
    sideMenu?.classList.remove('is-open');
    menuScrim?.classList.remove('is-open');
    menuToggle?.setAttribute('aria-expanded', 'false');
    sideMenu?.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
  };
  menuToggle?.addEventListener('click', () => {
    const open = !sideMenu?.classList.contains('is-open');
    sideMenu?.classList.toggle('is-open', open);
    menuScrim?.classList.toggle('is-open', open);
    menuToggle.setAttribute('aria-expanded', String(open));
    sideMenu?.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('is-locked', open);
  });
  menuScrim?.addEventListener('click', closeMenu);
  $$('a', sideMenu).forEach(link => link.addEventListener('click', closeMenu));

  $$('[data-popup-toggle]').forEach(button => button.addEventListener('click', () => button.closest('.popup-card')?.classList.add('is-open')));
  $$('[data-popup-close]').forEach(button => button.addEventListener('click', event => { event.stopPropagation(); button.closest('.popup-card')?.classList.remove('is-open'); }));
  $$('[data-popup-next]').forEach(button => button.addEventListener('click', () => {
    const track = button.closest('.popup-stores')?.querySelector('[data-popup-track]');
    track?.scrollBy({ left: Math.max(300, track.clientWidth * .58), behavior: 'smooth' });
  }));

  $$('[data-product-gallery]').forEach(gallery => {
    const viewport = $('[data-pdp-viewport]', gallery);
    const dots = $$('[data-pdp-dots] .pdp-dot', gallery);
    let ticking = false;
    const productIndex = () => viewport?.clientWidth ? Math.round(viewport.scrollLeft / viewport.clientWidth) : 0;
    const syncProductDots = () => {
      ticking = false;
      const index = productIndex();
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
    };
    viewport?.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(syncProductDots);
    }, { passive: true });
    $('[data-pdp-prev]', gallery)?.addEventListener('click', () => viewport?.scrollBy({ left: -viewport.clientWidth, behavior: 'smooth' }));
    $('[data-pdp-next]', gallery)?.addEventListener('click', () => viewport?.scrollBy({ left: viewport.clientWidth, behavior: 'smooth' }));

    const productSet = $('[data-gallery-set="product"]', gallery);
    const wornSet = $('[data-gallery-set="worn"]', gallery);
    const coverflow = $('[data-cf]', gallery);
    const coverflowItems = coverflow ? $$('.cf-item', coverflow) : [];
    const hint = $('.cf-hint', gallery);
    let coverflowIndex = 0;
    let nudged = false;
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    const hideHint = () => hint?.classList.add('is-hidden');
    const layoutCoverflow = () => {
      if (!coverflow || !coverflowItems.length) return;
      const width = coverflow.offsetWidth;
      const height = coverflow.offsetHeight;
      if (!width) return;
      coverflowItems.forEach((item, itemIndex) => {
        let offset = itemIndex - coverflowIndex;
        if (offset > coverflowItems.length / 2) offset -= coverflowItems.length;
        if (offset < -coverflowItems.length / 2) offset += coverflowItems.length;
        const distance = Math.abs(offset);
        const side = offset < 0 ? -1 : 1;
        let x;
        let y;
        let scale;
        let opacity;
        let zIndex;
        if (distance === 0) {
          x = 0; y = height * .04; scale = 1; opacity = 1; zIndex = 30;
        } else if (distance === 1) {
          x = side * width * .32; y = height * .02; scale = .55; opacity = 1; zIndex = 20;
        } else if (distance === 2) {
          x = side * width * .19; y = -height * .07; scale = .38; opacity = .4; zIndex = 10;
        } else {
          x = side * width * .19; y = -height * .07; scale = .3; opacity = 0; zIndex = 1;
        }
        item.style.transform = `translate(-50%,-50%) translateX(${x}px) translateY(${y}px) scale(${scale})`;
        item.style.opacity = opacity;
        item.style.zIndex = zIndex;
        item.style.pointerEvents = distance >= 1 && distance <= 2 ? 'auto' : 'none';
      });
    };
    const nudgeCoverflow = () => {
      if (nudged || coverflowItems.length < 2 || reducedMotion) return;
      nudged = true;
      setTimeout(() => {
        coverflowIndex = (coverflowIndex + 1) % coverflowItems.length;
        layoutCoverflow();
        setTimeout(() => {
          coverflowIndex = (coverflowIndex - 1 + coverflowItems.length) % coverflowItems.length;
          layoutCoverflow();
        }, 560);
      }, 380);
    };
    coverflowItems.forEach((item, itemIndex) => item.addEventListener('click', () => {
      coverflowIndex = itemIndex;
      layoutCoverflow();
      hideHint();
    }));
    if (coverflow) {
      coverflow.style.cursor = 'grab';
      let touchStart = null;
      let pointerStart = null;
      coverflow.addEventListener('touchstart', event => { touchStart = event.touches[0].clientX; }, { passive: true });
      coverflow.addEventListener('touchend', event => {
        if (touchStart === null) return;
        const delta = event.changedTouches[0].clientX - touchStart;
        if (Math.abs(delta) > 40) {
          coverflowIndex = (delta < 0 ? coverflowIndex + 1 : coverflowIndex - 1 + coverflowItems.length) % coverflowItems.length;
          layoutCoverflow();
          hideHint();
        }
        touchStart = null;
      });
      coverflow.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse') return;
        pointerStart = event.clientX;
        coverflow.style.cursor = 'grabbing';
      });
      coverflow.addEventListener('pointerup', event => {
        if (pointerStart === null) return;
        const delta = event.clientX - pointerStart;
        if (Math.abs(delta) > 40) {
          coverflowIndex = (delta < 0 ? coverflowIndex + 1 : coverflowIndex - 1 + coverflowItems.length) % coverflowItems.length;
          layoutCoverflow();
          hideHint();
        }
        pointerStart = null;
        coverflow.style.cursor = 'grab';
      });
      window.addEventListener('resize', layoutCoverflow);
    }
    $$('[data-gtoggle]', gallery).forEach(button => button.addEventListener('click', () => {
      const target = button.dataset.target;
      if (target === 'worn') {
        productSet?.setAttribute('hidden', '');
        wornSet?.removeAttribute('hidden');
      } else {
        wornSet?.setAttribute('hidden', '');
        productSet?.removeAttribute('hidden');
      }
      window.scrollTo({ top: gallery.offsetTop, behavior: 'auto' });
      if (target === 'worn') requestAnimationFrame(() => { layoutCoverflow(); nudgeCoverflow(); });
    }));
  });

  $$('[data-bundle-builder]').forEach(builder => {
    const root = builder.closest('[data-product-root]');
    const radios = $$('[data-tier-radio]', builder);
    const activate = radio => {
      radios.forEach(input => input.closest('.bundle-tier')?.classList.toggle('is-active', input === radio));
      const price = Number(radio.dataset.price || 0);
      $('[data-offer-title]', root).textContent = radio.dataset.title || '';
      $('[data-offer-price]', root).textContent = money(price);
      $('[data-installment]', root).textContent = money(price / 3);
      $('[data-button-price]', root).textContent = money(price);
      $('[data-sticky-title]') && ($('[data-sticky-title]').textContent = radio.dataset.title || '');
      $('[data-sticky-price]') && ($('[data-sticky-price]').textContent = money(price));
    };
    radios.forEach(radio => radio.addEventListener('change', () => activate(radio)));
    const defaultTier = builder.dataset.defaultTier;
    if (defaultTier) radios.forEach(radio => { radio.checked = radio.value === defaultTier; });
    const selected = radios.find(radio => radio.checked) || radios[0];
    if (selected) activate(selected);

    $$('[data-bundle-choice]', builder).forEach(select => {
      const label = $('[data-bundle-choice-label]', select.closest('.bundle-choice-control'));
      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        if (label) label.textContent = option?.dataset.choiceTitle || option?.textContent || select.getAttribute('aria-label');
      });
    });

    $('[data-add-bundle]', builder)?.addEventListener('click', async event => {
      const button = event.currentTarget;
      const active = radios.find(radio => radio.checked);
      if (!active) return;
      const tier = active.closest('.bundle-tier');
      const missingChoice = $$('[data-bundle-choice]', tier).find(select => !select.value);
      if (missingChoice) {
        toast('Choisis ton t-shirt et ton short avant d’ajouter l’ensemble.', true);
        const giftTrigger = $('[data-gift-open]', missingChoice.closest('.bundle-choice-control'));
        if (giftTrigger) giftTrigger.click();
        else missingChoice.focus();
        return;
      }
      const currentVariant = $('[data-current-variant]', tier)?.value;
      const parentVariant = active.dataset.parentVariant;
      const variantId = Number(parentVariant || currentVariant || 0);
      if (!variantId) {
        toast('Importe et publie les produits bundle avant de tester cette offre.', true);
        return;
      }
      const properties = { 'Offre': active.dataset.title || active.value };
      $$('[data-property-name]', tier).forEach(field => { if (field.dataset.propertyName && field.value) properties[field.dataset.propertyName] = field.value; });
      const checkoutItems = checkoutItemsForTier(active, tier, root);
      if (checkoutItems) properties['_CF Items'] = checkoutItems;
      button.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties }] })
        });
        if (!response.ok) throw new Error((await response.json()).description || 'Ajout impossible');
        toast();
        await refreshCart();
        openCart();
      } catch (error) { toast(error.message || 'Ajout impossible', true); }
      finally { button.disabled = false; }
    });
  });

  const giftPicker = $('[data-gift-picker]');
  const giftPickerTitle = $('[data-gift-picker-title]', giftPicker);
  const giftListView = $('[data-gift-picker-list-view]', giftPicker);
  const giftVariantView = $('[data-gift-picker-variant-view]', giftPicker);
  const giftSearch = $('[data-gift-picker-search]', giftPicker);
  const giftBack = $('[data-gift-picker-back]', giftPicker);
  const giftSpacer = $('[data-gift-picker-spacer]', giftPicker);
  const giftProductTitle = $('[data-gift-picker-product-title]', giftPicker);
  const giftVariantGrid = $('[data-gift-picker-variant-grid]', giftPicker);
  const giftEmpty = $('[data-gift-picker-empty]', giftPicker);
  let activeGiftKind = '';
  let activeGiftSelect = null;
  let activeGiftTrigger = null;
  let activeGiftProduct = null;

  const filterGiftProducts = () => {
    if (!giftPicker) return;
    const query = (giftSearch?.value || '').trim().toLocaleLowerCase('fr');
    let visible = 0;
    $$('[data-gift-product-card]', giftPicker).forEach(card => {
      const matchesKind = card.dataset.giftKind === activeGiftKind;
      const matchesSearch = !query || (card.dataset.giftSearchText || '').includes(query);
      card.hidden = !(matchesKind && matchesSearch);
      if (!card.hidden) visible += 1;
    });
    if (giftEmpty) giftEmpty.hidden = visible !== 0;
  };
  const showGiftList = () => {
    if (!giftPicker) return;
    giftListView.hidden = false;
    giftVariantView.hidden = true;
    giftBack.hidden = true;
    giftSpacer.hidden = false;
    giftVariantGrid.replaceChildren();
    activeGiftProduct = null;
    filterGiftProducts();
  };
  const showGiftVariants = card => {
    const template = $('[data-gift-variants]', card);
    if (!template || !giftVariantGrid) return;
    activeGiftProduct = card;
    giftListView.hidden = true;
    giftVariantView.hidden = false;
    giftBack.hidden = false;
    giftSpacer.hidden = true;
    giftProductTitle.textContent = $('.gift-picker__product-info>strong', card)?.textContent || '';
    giftVariantGrid.replaceChildren(template.content.cloneNode(true));
    $$('[data-gift-variant]', giftVariantGrid).forEach(button => button.classList.toggle('is-selected', button.dataset.giftValue === activeGiftSelect?.value));
  };
  const closeGiftPicker = () => {
    if (!giftPicker?.classList.contains('is-open')) return;
    giftPicker.classList.remove('is-open');
    giftPicker.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    activeGiftTrigger?.focus({ preventScroll: true });
  };
  const openGiftPicker = trigger => {
    if (!giftPicker) return;
    activeGiftTrigger = trigger;
    activeGiftSelect = $('[data-bundle-choice]', trigger.closest('.bundle-choice-control'));
    activeGiftKind = trigger.dataset.giftOpen || '';
    giftPickerTitle.textContent = trigger.dataset.giftDialogTitle || 'Choisis ton cadeau';
    if (giftSearch) {
      giftSearch.value = '';
      giftSearch.blur();
    }
    showGiftList();
    giftPicker.classList.add('is-open');
    giftPicker.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
  };

  $$('[data-gift-open]').forEach(trigger => trigger.addEventListener('click', () => openGiftPicker(trigger)));
  giftSearch?.addEventListener('input', filterGiftProducts);
  giftPicker?.addEventListener('click', event => {
    const closeButton = event.target.closest('[data-gift-picker-close]');
    if (closeButton) { closeGiftPicker(); return; }
    if (event.target.closest('[data-gift-picker-back]')) { showGiftList(); return; }
    const chooseProduct = event.target.closest('[data-gift-product-choose]');
    if (chooseProduct) { showGiftVariants(chooseProduct.closest('[data-gift-product-card]')); return; }
    const variantButton = event.target.closest('[data-gift-variant]');
    if (!variantButton || variantButton.disabled || !activeGiftSelect || !activeGiftTrigger) return;
    activeGiftSelect.value = variantButton.dataset.giftValue || '';
    activeGiftSelect.dispatchEvent(new Event('change', { bubbles: true }));
    const emptyLabel = $('[data-bundle-choice-label]', activeGiftTrigger);
    const selection = $('[data-gift-selection]', activeGiftTrigger);
    const changeLabel = $('[data-gift-change]', activeGiftTrigger);
    const selectedTitle = $('[data-gift-selected-title]', activeGiftTrigger);
    const selectedVariant = $('[data-gift-selected-variant]', activeGiftTrigger);
    if (emptyLabel) emptyLabel.hidden = true;
    if (selection) selection.hidden = false;
    if (changeLabel) changeLabel.hidden = false;
    activeGiftTrigger.classList.add('is-selected');
    if (selectedTitle) selectedTitle.textContent = variantButton.dataset.giftProductTitle || '';
    if (selectedVariant) selectedVariant.textContent = variantButton.dataset.giftVariantTitle || '';
    const lineImage = $('[data-gift-line-image]', activeGiftTrigger.closest('[data-gift-line]'));
    if (lineImage && variantButton.dataset.giftImage) {
      lineImage.src = variantButton.dataset.giftImage;
      lineImage.alt = variantButton.dataset.giftProductTitle || 'Cadeau sélectionné';
    }
    activeGiftTrigger.setAttribute('aria-label', `Changer ${variantButton.dataset.giftProductTitle || 'le cadeau'} ${variantButton.dataset.giftVariantTitle || ''}`.trim());
    closeGiftPicker();
  });

  const cartDrawer = $('[data-cart-drawer]');
  const openCart = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
  };
  const closeCart = () => {
    cartDrawer?.classList.remove('is-open');
    cartDrawer?.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
  };
  $$('[data-cart-open]').forEach(link => link.addEventListener('click', async event => { event.preventDefault(); await refreshCart(); openCart(); }));
  $$('[data-cart-close]').forEach(button => button.addEventListener('click', closeCart));

  let lastCart = null;
  const productCache = new Map();
  const tagIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12.3V5h7.3L21 15.7 15.7 21 5 10.3Z" fill="currentColor"/><circle cx="7.8" cy="7.8" r="1.2" fill="#fff"/></svg>';
  const trashIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 3h6l1 4H8l1-4Zm-2 4 1 14h8l1-14M10 11v6M14 11v6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const giftIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 10h16v11H4zM3 6h18v4H3zM12 6v15M12 6H8.7C5.6 6 5 2 7.8 2 10.6 2 12 6 12 6Zm0 0h3.3C18.4 6 19 2 16.2 2 13.4 2 12 6 12 6Z" fill="none" stroke="currentColor" stroke-width="1.65" stroke-linejoin="round"/></svg>';
  const sizeValues = ['XS', 'S', 'M', 'L', 'XL'];
  const optionMarkup = (values, selected, attributes, label) => `<select class="drawer-option" ${attributes} aria-label="${escapeHtml(label)}">${values.map(value => `<option value="${escapeHtml(value)}"${String(value).toLowerCase() === String(selected).toLowerCase() ? ' selected' : ''}>${escapeHtml(value)}</option>`).join('')}</select>`;
  const splitGift = value => {
    const parts = String(value || '').split(/\s+—\s+/);
    const productTitle = parts.shift() || '';
    const variantParts = parts.join(' — ').split(/\s*(?:\/|·)\s*/).filter(Boolean);
    return { productTitle, size: variantParts[0] || 'XS', color: variantParts[1] || '' };
  };
  const coreBundle = item => item.handle === 'bundle-ensemble-cy' || (String(item.product_title).toLowerCase().includes('ensemble cy') && Object.keys(item.properties || {}).some(key => key.includes('Hoodie CY')));
  const qtyMarkup = (quantity, removable = true) => `<div class="drawer-actions"><div class="drawer-qty"><button type="button" data-cart-change="${Math.max(0, quantity - 1)}" aria-label="Diminuer">−</button><span>${quantity}</span><button type="button" data-cart-change="${quantity + 1}" aria-label="Augmenter">+</button></div>${removable ? `<button class="drawer-remove" type="button" data-cart-change="0" aria-label="Supprimer">${trashIcon}</button>` : ''}</div>`;
  const priceMarkup = ({ finalPrice, comparePrice = 0, discount = 0, gift = false }) => `<div class="drawer-item__price">${discount > 0 ? `<small>${money(discount)} DE RÉDUCTION</small>` : ''}<strong>${money(finalPrice)}</strong>${comparePrice > finalPrice ? `<s>${money(comparePrice)}</s>` : ''}${gift ? `<span class="drawer-gift-icon">${giftIcon}</span>` : ''}</div>`;
  const bundleTag = label => `<div class="drawer-tag">${tagIcon}<span>${escapeHtml(label)}</span></div>`;
  const virtualItem = ({ line, item, title, handle, image, options = '', finalPrice, comparePrice, discount, tag, gift = false, size = '', color = '' }) => `<article class="drawer-item drawer-item--bundle" data-line="${line}" data-virtual-handle="${escapeHtml(handle || '')}" data-virtual-size="${escapeHtml(size)}" data-virtual-color="${escapeHtml(color)}">
    <img src="${escapeHtml(image || '')}" alt="${escapeHtml(title)}" data-virtual-image>
    <div class="drawer-item__main"><h4>${escapeHtml(title)}</h4><div class="drawer-options">${options}</div>${qtyMarkup(item.quantity)}${bundleTag(tag)}</div>
    ${priceMarkup({ finalPrice: finalPrice * item.quantity, comparePrice: comparePrice * item.quantity, discount: discount * item.quantity, gift })}
  </article>`;
  const renderCoreBundle = (item, line) => {
    const props = item.properties || {};
    const hoodieSize = props['Hoodie CY — Taille'] || 'XS';
    const hoodieColor = props['Hoodie CY — Couleur'] || 'Noir';
    const joggerSize = props['Jogging CY — Taille'] || 'XS';
    const joggerColor = props['Jogging CY — Couleur'] || 'Noir';
    const tee = splitGift(props['Cadeau T-shirt'] || 'Bitmap Tee — XS / Blanc');
    const short = splitGift(props['Cadeau Short'] || 'Short CY — XS / Noir');
    const teeHandle = tee.productTitle.toLowerCase().includes('used') ? 'used-tee' : 'bitmap-tee';
    const shortColor = short.color || (/rose/i.test(short.productTitle) ? 'Rose' : /gris/i.test(short.productTitle) ? 'Gris' : 'Noir');
    const shortHandle = /rose/i.test(shortColor) ? 'short-cy-rose' : /gris/i.test(shortColor) ? 'short-cy-gris' : 'shprt-cy-noir';
    const hoodieHandle = /gris/i.test(hoodieColor) ? 'hoodie-cy-gris' : 'cy-hoodie';
    const joggerHandle = /gris/i.test(joggerColor) ? 'jogging-cy-gris' : 'cy-jogger';
    const propOption = (key, selected, label) => optionMarkup(sizeValues, selected, `data-bundle-property="${escapeHtml(key)}"`, label);
    const giftOptions = (key, details, colors) => `${optionMarkup(sizeValues, details.size, `data-bundle-property="${escapeHtml(key)}" data-bundle-option="size" data-bundle-product="${escapeHtml(details.productTitle)}"`, `Taille ${details.productTitle}`)}${optionMarkup(colors, details.color || colors[0], `data-bundle-property="${escapeHtml(key)}" data-bundle-option="color" data-bundle-product="${escapeHtml(details.productTitle)}"`, `Couleur ${details.productTitle}`)}`;
    return [
      virtualItem({ line, item, title: 'Hoodie CY', handle: hoodieHandle, image: item.image, options: propOption('Hoodie CY — Taille', hoodieSize, 'Taille Hoodie CY'), finalPrice: 7968, comparePrice: 8499, discount: 531, tag: 'Ensemble CY', size: hoodieSize, color: hoodieColor }),
      virtualItem({ line, item, title: 'Jogging CY', handle: joggerHandle, options: propOption('Jogging CY — Taille', joggerSize, 'Taille Jogging CY'), finalPrice: 7032, comparePrice: 7499, discount: 467, tag: 'Ensemble CY', size: joggerSize, color: joggerColor }),
      virtualItem({ line, item, title: short.productTitle || 'Short CY', handle: shortHandle, image: cartDrawer?.dataset.giftShortImage, options: giftOptions('Cadeau Short', { ...short, color: shortColor }, ['Noir', 'Gris', 'Rose']), finalPrice: 0, comparePrice: 5499, tag: 'Short offert', gift: true, size: short.size, color: shortColor }),
      virtualItem({ line, item, title: tee.productTitle || 'Bitmap Tee', handle: teeHandle, image: cartDrawer?.dataset.giftTeeImage, options: giftOptions('Cadeau T-shirt', { ...tee, color: tee.color || (teeHandle === 'used-tee' ? 'Noir' : 'Blanc') }, teeHandle === 'used-tee' ? ['Noir'] : ['Blanc']), finalPrice: 0, comparePrice: 3499, tag: 'T-shirt offert', gift: true, size: tee.size, color: tee.color }),
      virtualItem({ line, item, title: 'Logo chain', handle: '', image: cartDrawer?.dataset.giftChainImage, finalPrice: 0, comparePrice: 4999, tag: 'Chaine offerte', gift: true })
    ].join('');
  };
  const renderRegularItem = (item, index) => {
    const compare = item.original_line_price || item.final_line_price;
    const discount = Math.max(0, compare - item.final_line_price);
    const discountTitle = item.discounts?.[0]?.title || Object.entries(item.properties || {}).find(([key]) => /offre|bundle/i.test(key))?.[1] || '';
    return `<article class="drawer-item" data-line="${index + 1}">
      <img src="${escapeHtml(item.image || '')}" alt="${escapeHtml(item.product_title)}">
      <div class="drawer-item__main"><h4>${escapeHtml(item.product_title)}</h4><div class="drawer-options" data-cart-options data-product-handle="${escapeHtml(item.handle)}" data-current-variant="${item.variant_id}">${item.variant_title && item.variant_title !== 'Default Title' ? `<span>${escapeHtml(item.variant_title)}</span>` : ''}</div>${qtyMarkup(item.quantity)}${discountTitle ? bundleTag(discountTitle) : ''}</div>
      ${priceMarkup({ finalPrice: item.final_line_price, comparePrice: compare, discount })}
    </article>`;
  };
  const renderCart = cart => {
    lastCart = cart;
    const visualCount = cart.items.reduce((count, item) => count + (coreBundle(item) ? 5 * item.quantity : item.quantity), 0);
    $$('[data-cart-count]').forEach(badge => { badge.textContent = visualCount; badge.hidden = visualCount === 0; });
    if (!cartDrawer) return;
    $('[data-drawer-count]', cartDrawer).textContent = visualCount;
    $('[data-cart-total]', cartDrawer).textContent = money(cart.total_price);
    $('[data-checkout-total]', cartDrawer).textContent = money(cart.total_price);
    $('[data-cart-installment]', cartDrawer).textContent = money(cart.total_price / 3);
    $('[data-checkout-button]', cartDrawer).disabled = cart.item_count === 0;
    const syntheticSavings = cart.items.reduce((sum, item) => sum + (coreBundle(item) ? 14995 * item.quantity : 0), 0);
    const savings = Math.max(Number(cart.original_total_price || 0) - Number(cart.total_price || 0), syntheticSavings);
    const saving = $('[data-cart-saving]', cartDrawer);
    if (saving) { saving.textContent = savings > 0 ? `Tu économises ${money(savings)}` : ''; saving.hidden = savings <= 0; }
    $$('[data-cart-filled-only]', cartDrawer).forEach(element => { element.hidden = cart.item_count === 0; });
    const items = $('[data-cart-items]', cartDrawer);
    if (!cart.items.length) { items.innerHTML = '<div class="cart-empty"><svg viewBox="0 0 48 48" aria-hidden="true"><path d="M8 9h5l4 23h20l4-16H15M19 39a2 2 0 1 0 0 .1M36 39a2 2 0 1 0 0 .1" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg><p>Panier vide</p></div>'; return; }
    items.innerHTML = cart.items.map((item, index) => coreBundle(item) ? renderCoreBundle(item, index + 1) : renderRegularItem(item, index)).join('');
    hydrateDrawerProducts();
  };
  async function getDrawerProduct(handle) {
    if (!handle) return null;
    if (!productCache.has(handle)) productCache.set(handle, fetch(`/products/${handle}.js`).then(response => response.ok ? response.json() : null).catch(() => null));
    return productCache.get(handle);
  }
  async function hydrateDrawerProducts() {
    await Promise.all($$('[data-cart-options]', cartDrawer).map(async container => {
      const product = await getDrawerProduct(container.dataset.productHandle);
      if (!product) return;
      const current = product.variants.find(variant => String(variant.id) === container.dataset.currentVariant) || product.variants[0];
      container.dataset.variants = JSON.stringify(product.variants.map(variant => ({ id: variant.id, available: variant.available, options: variant.options })));
      container.dataset.selectedOptions = JSON.stringify(current?.options || []);
      container.innerHTML = (product.options || []).map((name, optionIndex) => {
        const values = [...new Set(product.variants.map(variant => variant.options[optionIndex]).filter(Boolean))];
        if (values.length <= 1) return '';
        return optionMarkup(values, current?.options?.[optionIndex], `data-cart-option data-option-index="${optionIndex}"`, name);
      }).join('');
    }));
    await Promise.all($$('[data-virtual-handle]', cartDrawer).map(async article => {
      const product = await getDrawerProduct(article.dataset.virtualHandle);
      if (!product) return;
      const size = String(article.dataset.virtualSize || '').toLowerCase();
      const color = String(article.dataset.virtualColor || '').toLowerCase();
      const variant = product.variants.find(candidate => {
        const options = (candidate.options || []).map(option => String(option).toLowerCase());
        return (!size || options.includes(size)) && (!color || options.includes(color));
      });
      const image = variant?.featured_image?.src || product.featured_image || product.images?.[0];
      const target = $('[data-virtual-image]', article);
      if (target && image) target.src = image;
    }));
  }
  async function refreshCart() {
    const response = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    const cart = await response.json();
    renderCart(cart);
    return cart;
  }
  cartDrawer?.addEventListener('click', async event => {
    const upsellDirection = event.target.closest('[data-upsell-prev],[data-upsell-next]');
    if (upsellDirection) {
      const track = $('[data-upsell-track]', cartDrawer);
      const cards = track ? $$('article', track) : [];
      if (!track || !cards.length) return;
      const current = Math.max(0, Math.round(track.scrollLeft / Math.max(1, cards[0].offsetWidth + 10)));
      const target = Math.min(cards.length - 1, Math.max(0, current + (upsellDirection.hasAttribute('data-upsell-next') ? 1 : -1)));
      track.scrollTo({ left: cards[target].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      const index = $('[data-upsell-index]', cartDrawer);
      if (index) index.textContent = `${target + 1}/${cards.length}`;
      return;
    }
    const upsellButton = event.target.closest('[data-upsell-add]');
    if (upsellButton) {
      const select = upsellButton.closest('article')?.querySelector('[data-upsell-variant]');
      if (!select?.value) return;
      upsellButton.disabled = true;
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(select.value), quantity: 1 }] }) });
        if (!response.ok) throw new Error('Ajout impossible');
        await refreshCart();
      } catch (error) { toast(error.message || 'Ajout impossible', true); }
      finally { upsellButton.disabled = false; }
      return;
    }
    const button = event.target.closest('[data-cart-change]');
    if (!button) return;
    const line = Number(button.closest('[data-line]')?.dataset.line || 0);
    const quantity = Math.max(0, Number(button.dataset.cartChange || 0));
    if (!line) return;
    button.disabled = true;
    const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line, quantity }) });
    renderCart(await response.json());
  });
  cartDrawer?.addEventListener('change', async event => {
    const bundleSelect = event.target.closest('[data-bundle-property]');
    if (bundleSelect) {
      const line = Number(bundleSelect.closest('[data-line]')?.dataset.line || 0);
      const item = lastCart?.items?.[line - 1];
      if (!line || !item) return;
      const properties = { ...(item.properties || {}) };
      const key = bundleSelect.dataset.bundleProperty;
      if (bundleSelect.dataset.bundleOption) {
        const article = bundleSelect.closest('.drawer-item');
        const size = $('[data-bundle-option="size"]', article)?.value || 'XS';
        const color = $('[data-bundle-option="color"]', article)?.value || '';
        properties[key] = `${bundleSelect.dataset.bundleProduct || ''} — ${size}${color ? ` / ${color}` : ''}`;
      } else properties[key] = bundleSelect.value;
      bundleSelect.disabled = true;
      try {
        const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line, quantity: item.quantity, properties }) });
        renderCart(await response.json());
      } catch (_) { bundleSelect.disabled = false; }
      return;
    }
    const select = event.target.closest('[data-cart-option]');
    if (!select) return;
    const container = select.closest('[data-cart-options]');
    const line = Number(select.closest('[data-line]')?.dataset.line || 0);
    if (!line || !container) return;
    const variants = JSON.parse(container.dataset.variants || '[]');
    const selected = JSON.parse(container.dataset.selectedOptions || '[]');
    $$('[data-cart-option]', container).forEach(option => { selected[Number(option.dataset.optionIndex)] = option.value; });
    const variant = variants.find(candidate => candidate.available && candidate.options.every((value, index) => value === selected[index]));
    if (!variant) { toast('Cette combinaison est indisponible.', true); return; }
    select.disabled = true;
    try {
      const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line, id: Number(variant.id), quantity: lastCart?.items?.[line - 1]?.quantity || 1 }) });
      renderCart(await response.json());
    } catch (_) { select.disabled = false; }
  });

  let seconds = 600;
  const timer = $('[data-cart-timer] b');
  if (timer) setInterval(() => { seconds = Math.max(0, seconds - 1); timer.textContent = `${String(Math.floor(seconds / 60)).padStart(2,'0')}:${String(seconds % 60).padStart(2,'0')}`; }, 1000);
  const offerTimer = $('[data-offer-countdown]');
  if (offerTimer) {
    let offerSeconds = Number(offerTimer.dataset.countdownSeconds || 21037);
    const renderOfferTimer = () => {
      const h = Math.floor(offerSeconds / 3600), m = Math.floor((offerSeconds % 3600) / 60), s = offerSeconds % 60;
      offerTimer.textContent = offerTimer.dataset.countdownFormat === 'minutes'
        ? [Math.floor(offerSeconds / 60), s].map(n => String(n).padStart(2,'0')).join(' : ')
        : [h,m,s].map(n => String(n).padStart(2,'0')).join(' : ');
    };
    renderOfferTimer();
    setInterval(() => { offerSeconds = Math.max(0, offerSeconds - 1); renderOfferTimer(); }, 1000);
  }

  const sizeCalculator = $('[data-size-calculator]');
  const sizeModal = $('[data-size-modal]', sizeCalculator);
  const sizeBackdrop = $('[data-size-backdrop]', sizeCalculator);
  const sizeHeight = $('[data-height]', sizeCalculator);
  const sizeWeight = $('[data-weight]', sizeCalculator);
  const sizeHeightOutput = $('[data-height-output]', sizeCalculator);
  const sizeWeightOutput = $('[data-weight-output]', sizeCalculator);
  const sizeStepLabel = $('[data-size-step-label]', sizeCalculator);
  const sizeBack = $('[data-size-back]', sizeCalculator);
  const sizeNext = $('[data-size-next]', sizeCalculator);
  const sizeFitHint = $('[data-size-fit-hint]', sizeCalculator);
  const sizeFitContent = $('[data-size-fit-content]', sizeCalculator);
  const sizeResultTitle = $('[data-size-result-title]', sizeCalculator);
  const sizeResultSub = $('[data-size-result-sub]', sizeCalculator);
  const sizeResultCards = $('[data-size-result-cards]', sizeCalculator);
  const sizeResultExplain = $('[data-size-result-explain]', sizeCalculator);
  const sizeSavedBanner = $('[data-size-saved-banner]', sizeCalculator);
  const sizeSavedSummary = $('[data-size-saved-summary]', sizeCalculator);
  const sizeStorageKey = 'cynique_size_profile_v3';
  const sizeOrder = ['XS', 'S', 'M', 'L', 'XL'];
  const fitLabels = { slim: 'Ajusté', regular: 'Classique', oversize: 'Oversize' };
  const fitDescriptions = { slim: 'Près du corps.', regular: "La coupe d'origine, ni serrée ni ample.", oversize: 'Ample et décontracté.' };
  const morphoLabels = { athletic: 'Athlétique', standard: 'Standard', corpulent: 'Corpulent' };
  const sizeProfile = { height: 175, weight: 75, morpho: 'standard', fit: {}, unifiedFit: true };
  let sizeStep = 1;
  let sizeItems = [];
  let hasSavedSizeProfile = false;

  try {
    const saved = JSON.parse(localStorage.getItem(sizeStorageKey) || 'null');
    if (saved && typeof saved === 'object') {
      sizeProfile.height = Number(saved.height) || 175;
      sizeProfile.weight = Number(saved.weight) || 75;
      sizeProfile.morpho = morphoLabels[saved.morpho] ? saved.morpho : 'standard';
      sizeProfile.fit = saved.fit && typeof saved.fit === 'object' ? saved.fit : {};
      sizeProfile.unifiedFit = typeof saved.unifiedFit === 'boolean' ? saved.unifiedFit : true;
      hasSavedSizeProfile = true;
    }
  } catch (_) {}

  const syncSizeFields = () => {
    if (sizeHeight) sizeHeight.value = String(sizeProfile.height);
    if (sizeWeight) sizeWeight.value = String(sizeProfile.weight);
    if (sizeHeightOutput) sizeHeightOutput.innerHTML = `${sizeProfile.height}<span class="sc-value-unit">cm</span>`;
    if (sizeWeightOutput) sizeWeightOutput.innerHTML = `${sizeProfile.weight}<span class="sc-value-unit">kg</span>`;
    $$('[data-size-group="morpho"] .sc-card', sizeCalculator).forEach(card => card.classList.toggle('is-selected', card.dataset.sizeValue === sizeProfile.morpho));
  };

  const readSizeItems = () => {
    const productRoot = $('[data-product-root]');
    const family = productRoot?.dataset.family || 'core';
    const activeOffer = $('[data-tier-radio]:checked', productRoot);
    const offer = activeOffer?.value || '';
    const offerTitle = activeOffer?.dataset.title || $('[data-offer-title]', productRoot)?.textContent?.trim() || 'Produit CY';
    const productTitle = $('[data-product-root] .product-heading h1')?.textContent?.trim() || offerTitle;
    if (family === 'core') {
      if (offer === 'ensemble') return [{ id: 'ensemble', title: 'Ensemble CY', category: 'top' }, { id: 'gift', title: 'T-shirt offert', category: 'top', isGift: true }];
      return [{ id: 'main', title: productTitle, category: /jogg|pantalon/i.test(productTitle) ? 'bottom' : 'top' }];
    }
    if (family === 'shorts') {
      const items = [{ id: 'shorts', title: offerTitle, category: 'bottom' }];
      if (offer !== 'short-1') items.push({ id: 'gift', title: 'T-shirt offert', category: 'top', isGift: true });
      return items;
    }
    if (offer === 'tee-2') return [{ id: 'bitmap', title: 'Bitmap Tee', category: 'top' }, { id: 'used', title: 'Used Tee', category: 'top' }];
    return [{ id: 'main', title: offerTitle, category: 'top' }];
  };

  const renderFitCards = (group, current, compact = false) => `<div class="sc-cards${compact ? ' sc-cards--compact' : ''}" data-size-group="${escapeHtml(group)}">${['slim','regular','oversize'].map(fit => `<button class="sc-card${fit === current ? ' is-selected' : ''}" type="button" data-size-value="${fit}"><span class="sc-card-title">${fitLabels[fit]}</span>${compact ? '' : `<span class="sc-card-desc">${fitDescriptions[fit]}</span>`}</button>`).join('')}</div>`;
  const applyUnifiedFitView = () => {
    const unified = $('[data-size-fit-unified]', sizeFitContent);
    const split = $('[data-size-fit-split]', sizeFitContent);
    if (unified) unified.hidden = !sizeProfile.unifiedFit;
    if (split) split.hidden = sizeProfile.unifiedFit;
  };
  const renderFitStep = () => {
    sizeItems.forEach(item => { if (!sizeProfile.fit[item.id]) sizeProfile.fit[item.id] = 'regular'; });
    if (sizeItems.length <= 1) {
      const item = sizeItems[0];
      sizeFitHint.textContent = 'Choisis le tombé qui te correspond.';
      sizeFitContent.innerHTML = renderFitCards(`fit-${item.id}`, sizeProfile.fit[item.id]);
      return;
    }
    sizeFitHint.textContent = 'Choisis le tombé pour chaque pièce.';
    const firstFit = sizeProfile.fit[sizeItems[0].id] || 'regular';
    const split = sizeItems.map(item => `<div class="sc-fit-group"><div class="sc-fit-group-label">${escapeHtml(item.title)}</div>${renderFitCards(`fit-${item.id}`, sizeProfile.fit[item.id] || 'regular', true)}</div>`).join('');
    sizeFitContent.innerHTML = `<label class="sc-toggle"><input type="checkbox" data-size-unified${sizeProfile.unifiedFit ? ' checked' : ''}><span class="sc-toggle-track"></span><span class="sc-toggle-label">Appliquer le même tombé à tout l'ensemble</span></label><div data-size-fit-unified>${renderFitCards('fit-unified', firstFit)}</div><div data-size-fit-split hidden>${split}</div>`;
    applyUnifiedFitView();
  };

  const clampSizeIndex = index => Math.max(0, Math.min(sizeOrder.length - 1, index));
  const shiftSize = (size, delta) => sizeOrder[clampSizeIndex(sizeOrder.indexOf(size) + delta)];
  const baseSize = (height, weight, category) => {
    if (category === 'bottom') return height < 165 ? 'XS' : height < 170 ? 'S' : height < 175 ? (weight <= 70 ? 'S' : 'M') : height < 185 ? 'M' : height < 195 ? 'L' : 'XL';
    return height < 165 ? 'XS' : height < 175 ? 'S' : height < 180 ? (weight <= 70 ? 'S' : 'M') : height < 185 ? 'M' : height < 190 ? (weight <= 75 ? 'M' : 'L') : height < 200 ? 'L' : 'XL';
  };
  const nearSizeBoundary = (height, weight, category) => baseSize(height, Math.max(0, weight - 2), category) !== baseSize(height, weight, category) || baseSize(height, weight + 2, category) !== baseSize(height, weight, category);
  const recommendSize = item => {
    const bmi = sizeProfile.weight / ((sizeProfile.height / 100) ** 2);
    let size = baseSize(sizeProfile.height, sizeProfile.weight, item.category);
    if (bmi >= 31) size = shiftSize(size, 2);
    else if (bmi >= 28) size = shiftSize(size, 1);
    else if (item.category === 'top' && bmi <= 17) size = shiftSize(size, -1);
    const fit = sizeProfile.fit[item.id] || 'regular';
    if (fit === 'slim') size = shiftSize(size, -1);
    if (fit === 'oversize') size = shiftSize(size, 1);
    const outOfRange = sizeProfile.height < 155 || sizeProfile.height > 200 || bmi < 16 || bmi > 36;
    return { size, fit, confidence: outOfRange ? 85 : nearSizeBoundary(sizeProfile.height, sizeProfile.weight, item.category) ? 88 : 95 };
  };
  const renderSizeResult = () => {
    const results = sizeItems.map(item => ({ item, recommendation: recommendSize(item) }));
    const plural = results.length > 1;
    sizeResultTitle.textContent = plural ? 'Tes tailles idéales' : 'Ta taille idéale';
    sizeResultSub.textContent = `${sizeProfile.height} cm · ${sizeProfile.weight} kg · ${morphoLabels[sizeProfile.morpho]}`;
    sizeResultCards.innerHTML = results.map(({ item, recommendation }) => `<article class="sc-result-card${item.isGift ? ' sc-result-card--gift' : ''}"><div class="sc-result-card-head"><div class="sc-result-card-info"><div class="sc-result-item">${escapeHtml(item.title)}</div><div class="sc-result-fit">Tombé ${fitLabels[recommendation.fit]}</div><div class="sc-result-confidence">Fiabilité ${recommendation.confidence}%</div></div><div class="sc-result-size">${recommendation.size}</div></div></article>`).join('');
    sizeResultExplain.textContent = plural ? 'On a calculé chaque taille selon tes mensurations et les tombés choisis.' : 'On a calculé ta taille selon tes mensurations et le tombé choisi.';
    try { localStorage.setItem(sizeStorageKey, JSON.stringify(sizeProfile)); hasSavedSizeProfile = true; } catch (_) {}
  };
  const renderSavedSizeBanner = () => {
    if (!sizeSavedBanner) return;
    sizeSavedBanner.hidden = !hasSavedSizeProfile;
    if (!hasSavedSizeProfile || !sizeSavedSummary) return;
    const fits = sizeItems.map(item => sizeProfile.fit[item.id] || 'regular');
    const fitSummary = fits.length && fits.every(value => value === fits[0]) ? fitLabels[fits[0]] : 'tombés personnalisés';
    sizeSavedSummary.textContent = `${sizeProfile.height}cm, ${sizeProfile.weight}kg, ${morphoLabels[sizeProfile.morpho]}, ${fitSummary}`;
  };
  const goToSizeStep = step => {
    sizeStep = step;
    $$('[data-size-step]', sizeModal).forEach(panel => panel.classList.toggle('is-active', Number(panel.dataset.sizeStep) === step));
    if (sizeStepLabel) sizeStepLabel.textContent = `Étape ${step}/4`;
    $$('.sc-progress-dot', sizeCalculator).forEach((dot, index) => {
      dot.classList.toggle('is-active', index === step - 1);
      dot.classList.toggle('is-done', index < step - 1);
    });
    if (sizeBack) sizeBack.style.visibility = step === 1 ? 'hidden' : 'visible';
    if (sizeNext) sizeNext.textContent = step === 4 ? 'Voir le bundle' : 'Continuer';
    if (step === 3) renderFitStep();
    if (step === 4) renderSizeResult();
  };
  const openSizeModal = () => {
    if (!sizeModal) return;
    sizeItems = readSizeItems();
    sizeItems.forEach(item => { if (!sizeProfile.fit[item.id]) sizeProfile.fit[item.id] = 'regular'; });
    syncSizeFields();
    renderSavedSizeBanner();
    goToSizeStep(1);
    sizeModal.classList.add('is-open');
    sizeBackdrop?.classList.add('is-open');
    sizeModal.setAttribute('aria-hidden', 'false');
    sizeBackdrop?.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sc-locked');
  };
  const closeSizeModal = () => {
    sizeModal?.classList.remove('is-open');
    sizeBackdrop?.classList.remove('is-open');
    sizeModal?.setAttribute('aria-hidden', 'true');
    sizeBackdrop?.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sc-locked');
  };

  $('[data-size-open]')?.addEventListener('click', openSizeModal);
  $$('[data-size-close]', sizeCalculator).forEach(button => button.addEventListener('click', closeSizeModal));
  sizeBackdrop?.addEventListener('click', closeSizeModal);
  sizeHeight?.addEventListener('input', () => { sizeProfile.height = Number(sizeHeight.value); syncSizeFields(); });
  sizeWeight?.addEventListener('input', () => { sizeProfile.weight = Number(sizeWeight.value); syncSizeFields(); });
  sizeCalculator?.addEventListener('click', event => {
    const card = event.target.closest('.sc-card');
    if (!card) return;
    const group = card.closest('[data-size-group]');
    const groupName = group?.dataset.sizeGroup || '';
    const value = card.dataset.sizeValue || '';
    $$('.sc-card', group).forEach(item => item.classList.toggle('is-selected', item === card));
    if (groupName === 'morpho') sizeProfile.morpho = value;
    else if (groupName === 'fit-unified') {
      sizeItems.forEach(item => { sizeProfile.fit[item.id] = value; });
      $$('[data-size-group^="fit-"]', sizeFitContent).forEach(fitGroup => $$('.sc-card', fitGroup).forEach(item => item.classList.toggle('is-selected', item.dataset.sizeValue === value)));
    } else if (groupName.startsWith('fit-')) sizeProfile.fit[groupName.slice(4)] = value;
  });
  sizeCalculator?.addEventListener('change', event => {
    if (!event.target.matches('[data-size-unified]')) return;
    sizeProfile.unifiedFit = event.target.checked;
    if (sizeProfile.unifiedFit) {
      const value = sizeProfile.fit[sizeItems[0]?.id] || 'regular';
      sizeItems.forEach(item => { sizeProfile.fit[item.id] = value; });
    }
    applyUnifiedFitView();
  });
  $('[data-size-reset]', sizeCalculator)?.addEventListener('click', () => {
    sizeProfile.height = 175; sizeProfile.weight = 75; sizeProfile.morpho = 'standard'; sizeProfile.fit = {}; sizeProfile.unifiedFit = true; hasSavedSizeProfile = false;
    try { localStorage.removeItem(sizeStorageKey); } catch (_) {}
    syncSizeFields(); renderSavedSizeBanner();
  });
  sizeBack?.addEventListener('click', () => { if (sizeStep > 1) goToSizeStep(sizeStep - 1); });
  sizeNext?.addEventListener('click', () => {
    if (sizeStep < 4) { goToSizeStep(sizeStep + 1); return; }
    closeSizeModal();
    $('[data-bundle-builder]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  $$('[data-reels]').forEach(reels => {
    if (reels.dataset.ready) return;
    reels.dataset.ready = '1';
    const track = $('[data-reels-track]', reels);
    const cards = $$('[data-reel]', reels);
    const videos = cards.map(card => $('[data-reel-vid]', card));
    const pauseOthers = keep => cards.forEach((card, index) => {
      if (videos[index] === keep) return;
      videos[index]?.pause();
      card.classList.remove('is-playing');
    });
    cards.forEach((card, index) => {
      const video = videos[index];
      if (!video) return;
      const toggle = () => {
        if (video.paused) {
          pauseOthers(video);
          const playback = video.play();
          playback?.catch?.(() => {});
          card.classList.add('is-playing');
        } else {
          video.pause();
          card.classList.remove('is-playing');
        }
      };
      $('[data-reel-play]', card)?.addEventListener('click', event => {
        event.stopPropagation();
        toggle();
      });
      video.addEventListener('click', toggle);
      video.addEventListener('ended', () => card.classList.remove('is-playing'));
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) return;
        const index = cards.indexOf(entry.target);
        if (index < 0) return;
        videos[index]?.pause();
        entry.target.classList.remove('is-playing');
      }), { threshold: 0.35 });
      cards.forEach(card => observer.observe(card));
    }
    const step = direction => {
      const width = (cards[0]?.offsetWidth || 240) + 12;
      track?.scrollBy({ left: direction * width, behavior: 'smooth' });
    };
    $('[data-reels-prev]', reels)?.addEventListener('click', () => step(-1));
    $('[data-reels-next]', reels)?.addEventListener('click', () => step(1));
  });

  $$('[data-compare]').forEach(compare => {
    if (compare.dataset.compareBound) return;
    compare.dataset.compareBound = 'true';
    const beforeLabel = $('.cmp__lbl--l', compare);
    const afterLabel = $('.cmp__lbl--r', compare);
    let dragging = false;
    let position = 50;
    const setPosition = value => {
      position = Math.max(3, Math.min(97, value));
      compare.style.setProperty('--pos', `${position.toFixed(1)}%`);
      if (beforeLabel) beforeLabel.style.opacity = position < 25 ? '0' : '1';
      if (afterLabel) afterLabel.style.opacity = position > 75 ? '0' : '1';
    };
    const setPositionFromPointer = clientX => {
      const rect = compare.getBoundingClientRect();
      setPosition(((clientX - rect.left) / rect.width) * 100);
    };
    compare.addEventListener('pointerdown', event => {
      dragging = true;
      compare.classList.remove('cmp--anim');
      setPositionFromPointer(event.clientX);
      try { compare.setPointerCapture(event.pointerId); } catch (_) {}
    });
    compare.addEventListener('pointermove', event => { if (dragging) setPositionFromPointer(event.clientX); });
    compare.addEventListener('pointerup', () => { dragging = false; });
    compare.addEventListener('pointercancel', () => { dragging = false; });
    $('[data-compare-handle]', compare)?.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); setPosition(position - 2); }
      if (event.key === 'ArrowRight') { event.preventDefault(); setPosition(position + 2); }
      if (event.key === 'Home') { event.preventDefault(); setPosition(3); }
      if (event.key === 'End') { event.preventDefault(); setPosition(97); }
    });
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (!reducedMotion && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting || compare.dataset.swept) return;
          compare.dataset.swept = 'true';
          observer.unobserve(compare);
          compare.classList.add('cmp--anim');
          window.setTimeout(() => setPosition(72), 250);
          window.setTimeout(() => setPosition(28), 1050);
          window.setTimeout(() => setPosition(50), 1850);
          window.setTimeout(() => compare.classList.remove('cmp--anim'), 2650);
        });
      }, { threshold: 0.4 });
      observer.observe(compare);
    }
  });
  $('[data-sticky-add]')?.addEventListener('click', () => $('[data-add-bundle]')?.click());
  const stickyProduct = $('[data-sticky-product]');
  if (stickyProduct) {
    const syncStickyProduct = () => stickyProduct.classList.toggle('is-visible', window.scrollY > 700);
    syncStickyProduct();
    window.addEventListener('scroll', syncStickyProduct, { passive: true });
  }
  document.addEventListener('keydown', event => { if (event.key === 'Escape') { closeMenu(); closeCart(); closeGiftPicker(); closeSizeModal(); } });
})();
